import React, { useEffect, useMemo, useState } from "react";

const BackgroundChanger: React.FC = () => {
    const MINUTES_TO_CHANGE_BACKGROUND = 1; // Change this to the desired number of minutes
    
    const backgroundImages = useMemo(() => {    
        return [
            "/assets/images/back/background_1.jpg",
            "/assets/images/back/background_2.jpg",
            "/assets/images/back/background_3.jpg",
            "/assets/images/back/background_4.jpg",
            "/assets/images/back/background_5.jpg",
            "/assets/images/back/background_6.jpg",
            "/assets/images/back/background_7.jpg",
            "/assets/images/back/background_8.jpg",
            "/assets/images/back/background_9.jpg",
            "/assets/images/back/background_10.jpg",
            "/assets/images/back/background_11.jpg",
            "/assets/images/back/background_12.jpg",
            "/assets/images/back/background_13.jpg",
            "/assets/images/back/background_14.jpg",
            "/assets/images/back/background_15.jpg",
            "/assets/images/back/background_16.jpg",
            "/assets/images/back/background_17.jpg",
            "/assets/images/back/background_18.jpg",
            "/assets/images/back/background_19.jpg",
            "/assets/images/back/background_20.jpg",
            "/assets/images/back/background_21.jpg",
            "/assets/images/back/background_22.jpg",
            "/assets/images/back/background_23.jpg",
            "/assets/images/back/background_24.jpg"
        ];
    }, []);

    const [currentBackground, setCurrentBackground] = useState(backgroundImages[0]);

    useEffect(() => {
        let index = 0;

        const interval = setInterval(() => {
            index = Math.floor(Math.random() * backgroundImages.length); // Get a random index
            setCurrentBackground(backgroundImages[index]);
        }, MINUTES_TO_CHANGE_BACKGROUND * 60 * 1000);

        // Cleanup interval on component unmount
        return () => clearInterval(interval);
    }, [backgroundImages]);

    useEffect(() => {
        // Update the <body> background style
        document.body.style.background = `#1b2024 url('${currentBackground}') center 55px no-repeat`;
    }, [currentBackground]);

    return null; // This component doesn't render anything
};

export default BackgroundChanger;